import { useState } from 'react';

import type {
  DialogConfig,
  UseDialogStateParams,
  UseDialogStateReturn
} from './SourceCreateDialog.types';
import { isAutoSocUnsupportedSource } from './SourceCreateDialog.utils';

/**
 * Custom hook to manage dialog-level state including:
 * - Confirmation dialog configuration
 * - Submission loading state
 * - Auto SOC unsupported source warnings
 *
 * @param params - Source type ID and tiered source types for Auto SOC validation
 * @returns Dialog state and setters
 */
export const useDialogState = ({
  selectedSourceTypeId,
  tieredSourceTypes
}: UseDialogStateParams): UseDialogStateReturn => {
  const [dialogConfig, setDialogConfig] = useState<DialogConfig>({
    title: '',
    message: '',
    button: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Detect if selected source is unsupported for Auto-SOC
  const isAutoSocUnsupportedSourceSelected = isAutoSocUnsupportedSource(
    selectedSourceTypeId,
    tieredSourceTypes
  );

  return {
    dialogConfig,
    setDialogConfig,
    isSubmitting,
    setIsSubmitting,
    isAutoSocUnsupportedSourceSelected
  };
};
